<template>
  <fieldset :class="['radio', { 'radio--error': error, 'radio--disabled': disabled }]">
    <div class="radio__options">
      <label class="radio__option" v-for="(item, i) in list" :key="i">
        <input class="visually-hidden radio__input" :value="item.id" type="radio" :disabled="disabled" @click="check(item.id)" />
        <span :class="['radio__state', { 'radio__state--checked': isChecked(item.id) }]"></span>
        <span v-if="item.label" class="radio__label">
          {{ item.label }}
        </span>
      </label>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'RadioGroup',
  emits: ['input'],
  props: {
    value: {
      type: Number,
      default: 1,
    },
    list: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    check(value) {
      this.$emit('input', value)
    },
    isChecked(itemValue) {
      return this.value === itemValue
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.radio
  &--disabled
    opacity: var(--field-opacity-disabled, 0.7)
    pointer-events: none

    .radio__state
      background-color: var(--field-disabled-bg-color, #ededed)

  &--error
    .radio__state
      border-color: $error

  &__options
    display: flex
    flex-direction: column
    align-items: flex-start
    gap: 8px

  &__option
    display: flex
    gap: 12px

  &__state
    position: relative
    min-width: 24px
    width: 24px
    height: 24px
    border-radius: 50%
    border: var(--field-border-width, 1px) solid var(--field-checkbox-border-color, #C8C8C8)
    transition: all .2s

    &:before
      content: ''
      opacity: 0
      position: absolute
      top: 4px
      left: 4px
      width: 14px
      height: 14px
      background-color: var(--field-icon-color, $cyan)
      border-radius: 50%
      transition: opacity .2s

    &--checked
      opacity: 1

      &:before
        opacity: 1

  &__label
    font-size: 14px
    line-height: 24px
    color: var(--field-text-color, $black)
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/RadioGroup.vue